// @ts-nocheck
import { canUserSeePrices } from "@store/Framework/Store/Data/Accounts/AccountsSelectors";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

export default () => {
    return useAppSelector(state => canUserSeePrices(state));
};
